import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { css } from 'aphrodite';
import styles from './styles';
import { useStore } from '~/src/hooks/useMst';
import FolderPickerPreviousFolderDeletedBanner from './FolderPickerPreviousFolderDeletedBanner';
import FolderPickerRegularInfoBanner from './FolderPickerRegularInfoBanner';

export type FolderPickerContextBannerProps = {
  currentMatterName: string;
};

const FolderPickerContextBanner = observer(
  ({ currentMatterName }: FolderPickerContextBannerProps) => {
    const { clio: clioStore } = useStore();

    const previousFolderDeleted =
      clioStore?.courtFormIsClioFolderDeleted || false;
    const projectName =
      clioStore?.courtFormProjectName?.trim() || 'Current Project';

    return (
      <Fragment>
        {/* Info Banner - Show when previousFolderDeleted is true */}
        {previousFolderDeleted && (
          <FolderPickerPreviousFolderDeletedBanner
            currentMatterName={currentMatterName}
            projectName={projectName}
          />
        )}

        {/* Info Banner - Only show when previousFolderDeleted is false */}
        {!previousFolderDeleted && (
          <FolderPickerRegularInfoBanner
            currentMatterName={currentMatterName}
            projectName={projectName}
          />
        )}

        {/* Context Banner */}
        <div className={css(styles.contextBanner)}>
          <div className={css(styles.contextBannerText)}>
            Only showing folders within {currentMatterName}
          </div>
        </div>
      </Fragment>
    );
  },
);

export default FolderPickerContextBanner;
